import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Open from './icon-open.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Open {...validProps} />;
}
SvgComponent.iconName = 'open';

/**
 * @deprecated This is a legacy icon
 */
export const OpenIcon = svgIconWrapper(SvgComponent);
